import { render, staticRenderFns } from "./listOld.vue?vue&type=template&id=8bb855f8&scoped=true"
import script from "./listOld.vue?vue&type=script&lang=js"
export * from "./listOld.vue?vue&type=script&lang=js"
import style0 from "./listOld.vue?vue&type=style&index=0&id=8bb855f8&prod&lang=less"
import style1 from "./listOld.vue?vue&type=style&index=1&id=8bb855f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb855f8",
  null
  
)

export default component.exports